<template>
  <div class="tc-tz-selector">
    <label class="tc-tz-selector-label" for="tz-select">Timezone</label>
    <select
      id="tz-select"
      class="form-select form-select-sm tc-tz-select"
      data-testid="tz-select"
      :value="tzStore.selectedZone"
      @change="tzStore.setZone(($event.target as HTMLSelectElement).value)"
    >
      <option
        v-for="zone in zones"
        :key="zone"
        :value="zone"
      >{{ zone }}</option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { useTimezoneStore, getSupportedZones } from '../stores/timezone';

const tzStore = useTimezoneStore();
const zones = getSupportedZones();
</script>
